import { Fragment } from 'react';

import useGroupContextView from './UseGroupContextView';

import Headings from '@usas/ui-web/components/headings/Headings';
import PageNotFound from '@usas/ui-web/components/PageNotFound';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import LargeContextBasedNav from '@usas/ui-web/components/contextBasedNav/LargeContextBasedNav';
import MobileContextBasedNav from '@usas/ui-web/components/contextBasedNav/MobileContextBasedNav';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GroupContextView = ({ children }) => {
  const {
    isError,
    isLoading,
    homeRoute,
    taxonomyName,
    backToLabel,
    groupInfoObj,
    onHomeClicked,
    onBackToClicked
  } = useGroupContextView();

  if (isLoading) {
    return <LoadingModal />;
  }

  if (isError) {
    return (
      <Fragment>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToClicked}>
              <LeftArrowIcon /> {backToLabel}
            </button>
          </div>
        </div>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PageNotFound />
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <button className={global.HeaderButton} onClick={onHomeClicked}>
            <Headings.H3
              className={[global.NoBottomMargin, 'col-xs-12'].join(' ')}
              excludeBar={true}>
              View/Edit Group
            </Headings.H3>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <hr className="usas-bar-turmeric" />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <button className={global.BackToSearchButton}
            type="button"
            onClick={onBackToClicked}>
            <LeftArrowIcon /> {backToLabel}
          </button>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <p className={global.HeaderText}><strong>Group Name:</strong>&nbsp;{groupInfoObj.groupName || ''}</p>
          <p className={global.HeaderText}><strong>Group Code:</strong>&nbsp;{groupInfoObj.groupCode || ''}</p>
          <p className={global.HeaderText}><strong>Group Type:</strong>&nbsp;{groupInfoObj.groupType?.typeName || ''}</p>
        </div>
      </div>
      <div className="row">
        <div className="visible-xs col-xs-12">
          <MobileContextBasedNav taxonomyName={taxonomyName} renderPillsOnly={true} />
        </div>
        <div className="hidden-xs col-xs-12">
          <LargeContextBasedNav taxonomyName={taxonomyName} homeRoute={homeRoute} renderPillsOnly={true} />
        </div>
      </div>
      {children}
    </Fragment>
  );
};

export default GroupContextView;